import ChartTheme from './chartTheme';

// function switchButtonClass (e: any) {
//   const event = e || window.event;
//   const prevSelectedBox = document.getElementsByClassName('stock-tab-action')[0] as HTMLElement;
//   if (prevSelectedBox) {
//     prevSelectedBox.setAttribute('class', 'highcharts-button highcharts-button-normal');
//     // prevSelectedBox.classList.remove('stock-tab-action'); // ie 不兼容
//   }
//   event.target.parentNode.setAttribute('class', 'highcharts-button stock-tab-action highcharts-button-pressed');
//   // event.target.parentNode.classList.add('stock-tab-action'); // ie 不兼容
// }

const StockTheme = {
  ...ChartTheme,
  global: {
    useUTC: false,
  },
  rangeSelector: {
    labelStyle: {
      color: '#fff',
    },
    inputDateFormat: '%Y-%m-%d',
    inputBoxWidth: 80,
    inputBoxHeight: 16,
    inputBoxBorderColor: 'rgb(77, 77, 87)',
    inputStyle: {
      color: '#FFF',
      background: '#2A2E3C',
    },
    buttonTheme: {
      width: 38,
      height: 16,
      top: 5,
      r: 2,
      fill: '#363642',
      style: {
        color: '#fff',
      },
      states: {
        hover: {
          fill: '#32364B',
          style: {
            color: '#fff',
          }
        },
        select: {
          fill: '#ffab2e',
          style: {
            color: '#000',
            fontWeight: 'normal',
            y: 120,
          }
        }
      }
    },
    selected: 2,
    buttons: [{
      type: 'month',
      count: 1,
      text: '1月',
      // events: {
      //   click: switchButtonClass,
      // },
    }, {
      type: 'month',
      count: 3,
      text: '3月',
      // events: {
      //   click: switchButtonClass,
      // }
    }, {
      type: 'month',
      count: 6,
      text: '6月',
      // events: {
      //   click: switchButtonClass,
      // }
    }, {
      type: 'year',
      count: 1,
      text: '1年',
      // events: {
      //   click: switchButtonClass,
      // }
    }, {
      type: 'ytd',
      text: '今年来',
      // events: {
      //   click: switchButtonClass,
      // }
    },  {
      type: 'all',
      text: '所有',
      // events: {
      //   click: switchButtonClass,
      // }
    }],    
  },
  navigator: {
    xAxis: {
      labels: { // 导航轴日期格式设置
        format: '{value:%Y-%m}',
      }
    }
  },
  lang: {
    rangeSelectorFrom: '起：',
    rangeSelectorTo: '止：',
    rangeSelectorZoom: '范围：',
  },
  scrollbar: {
    enabled: false
  },
};

export default StockTheme;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSChart/stockTheme.ts